import { InfoCircleOutlined } from "@ant-design/icons";
import Tooltip from "antd/es/tooltip";
import { Typography } from "components/styleguide";
import {
  ForumDelegatesInformation,
  ForumOtherInformation,
  ForumSpeakersInformation,
  ForumSuppliersInformation,
} from "generated/api";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.less";

interface TooltipItem {
  label: string;
  description: string;
}

interface SummaryListItemProps {
  title: string;
  stats?: ForumDelegatesInformation | ForumSpeakersInformation | ForumSuppliersInformation | ForumOtherInformation;
  tooltipItems?: TooltipItem[];
}

const SummaryListItem: FC<SummaryListItemProps> = ({ title, stats, tooltipItems = [] }) => {
  const { t } = useTranslation();
  const { Title } = Typography;
  const tooltipTitle = (
    <div className={styles.tooltipContent}>
      {tooltipItems.map((item) => (
        <div className={styles.tooltipItem} key={item.label}>
          <strong>{t(item.label)}</strong>
          <span>{t(item.description)}</span>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <div className={styles.title}>
        <Title level={5}>{t(title)}</Title>
        {tooltipItems.length > 0 && (
          <Tooltip overlayClassName={styles.tooltipOverlay} placement="bottomRight" title={tooltipTitle}>
            <InfoCircleOutlined className={styles.tooltipIcon} />
          </Tooltip>
        )}
      </div>
      {stats ? (
        <ul className={styles.stats}>
          {Object.entries(stats)?.map(([key, value]) => (
            <li key={key}>{`${value} ${t(`summaryStatistics.${key}`)}`}</li>
          ))}
        </ul>
      ) : (
        "-"
      )}
    </>
  );
};

export default SummaryListItem;
